import React from 'react';
import {BrowserRouter as Router, Redirect, Route, Switch} from "react-router-dom";
import SignIn from "../container/auth/signIn/login";
import SignUp from "../container/auth/signIn/signup";
import MainLayoutRoutes from "./mainRoutes";
import Dashboard from "../components/dashboard/dashboard";
import ProductDetail from "../container/productDetail/productDetail";
import ServiceDetail from "../container/productDetail/serviceDetail";
import Result from '../container/result';
import ServicesResult from '../container/result/serviceResults';
import ShoppingSummary from '../container/shoppingSummary';
import NewHomePage from '../container/newHomePage'
import PrivacyPage from '../container/privacy'
import SupportTicket from '../container/supportTicket'
import AddNewProduct from '../container/addNewProduct/addNewProduct'
import ProductListing from '../container/productsListing'
import Checkout from '../container/checkoutPage'
import MyProducts from '../container/dashboard/myProducts/myProducts'
import MyServices from '../container/dashboard/myServices/myServices'
import Orders from '../container/dashboard/orders'
import BidsAgainst from '../container/dashboard/bidsAgainstHarvest'
import MyBids from '../container/dashboard/myBids'
import MyHarvest from '../container/dashboard/myHarvest/myHarvest'
import AddAlert from '../container/dashboard/addNewAlert/addNewAlert'
import AddNewService from "../container/addNewService/addNewService";
import AddNewHarvest from "../container/addNewHarvest/addNewHarvest";
import SavedAlerts from "../container/savedAlerts/savedAlerts";
import SavedSearches from "../container/dashboard/savedSearches/savedSearches";
import NewSearches from "../container/dashboard/addNewSearch/addNewSearch";
import ProductSmartDetail from "../container/productDetail/productSmartDetail";
import UserProfile from "../container/dashboard/userProfile/userProfile";
import "react-multi-carousel/lib/styles.css";
import {Confirmation} from '../components';
import AboutUsPage from "../container/aboutUs";

function Routes(props) {
  return (
    <Router>
      <Switch>

        <Route path="/" key={'homeKey'} exact component={NewHomePage}/>
        <Redirect from="/newindex" to="/"/>
        <Route path="/signIn" exact component={SignIn}/>
        <Route path="/reset-password" exact component={SignIn}/>
        <Route path="/signup" exact component={SignUp}/>
        <Route path="/detail/:id" exact component={ProductDetail}/>
        <Route path="/serviceDetail/:id" exact component={ServiceDetail}/>
        <Route path="/result" exact component={Result}/>
        <Route path="/services" exact component={ServicesResult}/>
        <Route path="/summary" exact component={ShoppingSummary}/>
        <Route path="/support" exact component={SupportTicket}/>
        <Route path="/addProduct" exact component={AddNewProduct}/>
        <Route path="/products" exact component={ProductListing}/>
        <Route path="/checkout" exact component={Checkout}/>
        <Route path="/privacyPage" exact component={PrivacyPage}/>
        <Route path="/aboutUs" key={'aboutUs'} exact component={AboutUsPage}/>

        <MainLayoutRoutes exact path="/dashboard" render={matchprops => (<Dashboard {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/myproducts" render={matchprops => (<MyProducts {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/newproduct" render={matchprops => (<AddNewProduct {...matchprops} />)}/>
        <MainLayoutRoutes exact path='/editproduct/:id' render={matchprops => (<AddNewProduct {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/productDetail" render={matchprops => (<ProductSmartDetail {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/myservices" render={matchprops => (<MyServices {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/orders" render={matchprops => (<Orders {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/addService" render={matchprops => (<AddNewService {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/bids" render={matchprops => (<BidsAgainst {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/myBids" render={matchprops => (<MyBids {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/myharvest" render={matchprops => (<MyHarvest {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/addharvest" render={matchprops => (<AddNewHarvest {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/savedAlert" render={matchprops => (<SavedAlerts {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/addalert" render={matchprops => (<AddAlert {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/newSearch" render={matchprops => (<NewSearches {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/myrequirements" render={matchprops => (<SavedSearches {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/searchResult" render={matchprops => (<SavedSearches {...matchprops} />)}/>
        <MainLayoutRoutes exact path="/userprofile" render={matchprops => (<UserProfile {...matchprops} />)}/>

        <Redirect to={'/'}/>
      </Switch>
      <Confirmation/>
    </Router>
  );
}


export default Routes;
